import { render, staticRenderFns } from "./BasePopupThumbnailPreview.vue?vue&type=template&id=40da9f17&scoped=true"
import script from "./BasePopupThumbnailPreview.vue?vue&type=script&lang=js"
export * from "./BasePopupThumbnailPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da9f17",
  null
  
)

export default component.exports